import React from 'react';

import type { AgentLog } from '../store/services/planningRuntimeApi';



interface AgentLogTableProps {
  logs: AgentLog[];
}

export const AgentLogTable: React.FC<AgentLogTableProps> = ({ logs }) => (
  <table className="agent-log-table">
    <thead>
      <tr>
        <th>Time</th>
        <th>Agent</th>
        <th>Action</th>
        <th>Summary</th>
      </tr>
    </thead>
    <tbody>
      {logs.length === 0 ? (
        <tr>
          <td colSpan={4} className="no-logs">
            No activity recorded yet
          </td>
        </tr>
      ) : (
        logs.map((log) => (
          <tr key={log.id}>
            <td data-label="Time">{new Date(log.created_at).toLocaleTimeString()}</td>
            <td data-label="Agent">{log.agent_type}</td>
            <td data-label="Action">
              <span className={`status-badge ${log.action}`}>{log.action}</span>
            </td>
            <td data-label="Summary">{log.summary || '-'}</td>
          </tr>
        ))
      )}
    </tbody>
  </table>
);
